import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '';

export default function ImpersonatePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);
  const [orgInfo, setOrgInfo] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('No impersonation token provided');
      setStatus('error');
      return;
    }

    axios
      .post(`${API_URL}/api/auth/impersonate`, { token })
      .then((res) => {
        const { token: sessionToken, user, organization, impersonatedBy } = res.data;

        // Store impersonation session
        localStorage.setItem('token', sessionToken);
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('isImpersonated', 'true');
        localStorage.setItem('impersonatedBy', impersonatedBy || '');
        localStorage.setItem('impersonatedOrg', JSON.stringify(organization));

        setOrgInfo(organization);
        setStatus('success');

        setTimeout(() => navigate('/dashboard'), 1500);
      })
      .catch((err) => {
        setError(err.response?.data?.error || 'Impersonation failed');
        setStatus('error');
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 rounded-lg p-8 max-w-md w-full text-center">
        {status === 'processing' && (
          <>
            <div className="animate-spin w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4" />
            <p className="text-gray-300">Setting up impersonation session...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-white font-medium mb-1">Impersonation active</p>
            <p className="text-gray-400 text-sm">Viewing as: {orgInfo?.name}</p>
            <p className="text-gray-500 text-xs mt-2">Redirecting to dashboard...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <p className="text-white font-medium mb-1">Impersonation failed</p>
            <p className="text-red-400 text-sm">{error}</p>
            <button
              onClick={() => window.close()}
              className="mt-4 px-4 py-2 bg-gray-700 text-gray-300 rounded hover:bg-gray-600 text-sm"
            >
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
}
